<div class="container-div">
  <button class="cross-box" (click)="close(false)">
    <div class="cross-icon"></div>
  </button>
  <div class="form-group">
    <label>Change your mobile number</label>
    <input [formControl]="mobile" type="text" maxlength="10" (input)="onInput($event, 'mobile')" />
  </div>
  @if (otpId) {
  <div class="form-group">
    <label>Enter OTP</label>
    <input [formControl]="otp" type="text" maxlength="6" (input)="onInput($event, 'otp')" />
  </div>
  }
  <button
    class="edit-btn"
    [disabled]="
      otpId ? mobile.invalid || otp.invalid : mobile.getRawValue() === data || mobile.invalid
    "
    (click)="otpId ? updateMobile() : getOtp()"
  >
    {{ otpId ? 'Update Mobile' : 'Get OTP' }}
  </button>
</div>
